import { render, staticRenderFns } from "./DataReportEarnedStatistics.vue?vue&type=template&id=8dbf52ce&scoped=true"
import script from "./DataReportEarnedStatistics.vue?vue&type=script&lang=js"
export * from "./DataReportEarnedStatistics.vue?vue&type=script&lang=js"
import style0 from "./DataReportEarnedStatistics.vue?vue&type=style&index=0&id=8dbf52ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dbf52ce",
  null
  
)

export default component.exports